import { useLiveQuery } from "dexie-react-hooks";
import { db, clearHistory } from "../../services/db";
import HistoryItem from "./HistoryItem";
import "./history.scss";
import { DeleteForeverOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

const History = () => {
	const historyItems = useLiveQuery(() => db.history.toArray(), []);

	return (
		<div className="history-wrapper">
			<div className="history-header">
				<h1>History</h1>
				<Button
					color="secondary"
					variant="outlined"
					startIcon={<DeleteForeverOutlined />}
					onClick={() => {
						if (window.confirm("Are you sure you want to clear the history?")) {
							clearHistory();
						}
					}}
				>
					Clear History
				</Button>
			</div>
			<div className="history-list">
				{historyItems?.length && historyItems.reverse().map((item) => <HistoryItem key={item.id} historyItem={item} />)}
			</div>
		</div>
	);
};

export default History;
